module.exports = __webpack_public_path__ + "static/media/icon-service.962e86c9.svg";